import { AsideArea } from "@/components/templates/SidebarLayout/AsideArea";
import { MainDashboardContentDomID } from "@/constants/mainDashboardContentDomID";
import "./SidebarLayout.scss";

export const SidebarLayout: React.FC<{ sidebar?: React.ReactNode; children?: React.ReactNode }> = ({
  sidebar,
  children,
}) => {
  return (
    <div className="app-layout">
      <AsideArea sidebar={sidebar} />
      <main id={MainDashboardContentDomID}>{children}</main>
    </div>
  );
};
